import type { LinkedDatapoint } from '@domain/schemas/block.schema';
import { extractDataPointsFromHTML } from '@root/helpers/schema';

export const updateDatapointsFromContent = (
  content: string | undefined,
  currentLinkedDatapoints: LinkedDatapoint[] = [],
) => {
  if (content) {
    return extractDataPointsFromHTML(content ?? '', currentLinkedDatapoints);
  }

  return currentLinkedDatapoints;
};
